import { Controller } from "@hotwired/stimulus"
import { deviceTypeStore } from '../../stores/device_types/device_type_store'
import { paperTypeStore } from "../../stores/print_mapping/paper_type_store"
import { useStore } from 'stimulus-store'
import { isEmpty } from "lodash"
import { getPaperTypes } from "../../packs/print_mapping/paper_types"
import { sendFailureNotification } from "shared/toast_notifications"

// Connects to data-controller="forms--tray-mapping-widget"
export default class extends Controller {

    static stores = [
        deviceTypeStore,
        paperTypeStore
    ];

    static targets = [];

    static values = {
        initialDeviceTypeId: String
    };

    connect() {
        useStore(this);
        
        // Fetch paper types for the selects
        this._getPaperTypes();
    }

    /**
     * Store Integration: Device type store callback
     *
     * Called automatically by stimulus-store when deviceTypeStore updates.
     * Updates widget visibility based on whether device type is a printer.
     *
     * @param {Object} event - Device type store state
     */
    onDeviceTypeStoreUpdate(event) {
        this.updateVisibility();
    }

    /**
     * Visibility Management: Update widget visibility
     *
     * Shows or hides the widget based on whether the device type is a printer.
     * Uses Bootstrap d-none class for consistent styling.
     */
    updateVisibility() {
        const container = this.element;
        
        if (!container) {
            return;
        }

        const isPrinter = this.isPrinter();

        if (isPrinter) {
            container.classList.remove('d-none');
        } else {
            container.classList.add('d-none');
        }
    }

    /**
     * Printer Detection: Check if device type is a printer
     *
     * Determines if the current device type is a printer by checking
     * the printer property in the device type.
     *
     * @returns {Boolean} True if device type is a printer, false otherwise
     */
    isPrinter() {
        return this.deviceTypeStoreValue?.printer === true;
    }

    /**
     * Data Fetching: Fetch paper types with error handling
     *
     * Fetches paper types from the API and updates the paper type store.
     * Handles errors gracefully with toast notifications.
     */
    async _getPaperTypes() {
        try {
            const paperTypes = await getPaperTypes();
            this.setPaperTypeStoreValue(paperTypes);
        } catch (error) {
            console.error('Error fetching paper types:', error);
            sendFailureNotification('Unable to load paper types. Please refresh the page or contact support.');
            this.setPaperTypeStoreValue([]);
        }
    }
}
